module.exports = __webpack_public_path__ + "media/images/react/search/info-26668f768f7afba109456e2fee06b10a.svg";